import { FC, MouseEvent as ReactMouseEvent, useCallback, useState } from 'react';
import { getEasyLayout } from '@resistdesign/voltra/app/utils';
import styled from 'styled-components';
import ToS from 'url:../Assets/Documents/Terms of Service.pdf';
import PrivacyPolicy from 'url:../Assets/Documents/Privacy Policy.pdf';

const DOCUMENTS: {
  label: string;
  url: string;
}[] = [
  {
    label: 'Terms of Service',
    url: ToS,
  },
  {
    label: 'Privacy Policy',
    url: PrivacyPolicy,
  },
];

const {
  layout: Layout,
  areas: { Left, Center, Right },
} = getEasyLayout(
  styled.div`
    overflow: auto;
    width: 100%;
    height: 100%;
  `
)`
    left center right, 1fr
    \\ 1fr 2fr 1fr
`;
const CenterLayout = styled(Center)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 1em;
`;
const DocFrame = styled.iframe`
  flex: 1 1 auto;
  min-height: 20em;
`;
const Controls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1em;
`;

export type DocumentsProps = {
  onAccept: () => void;
  onCancel: () => void;
};

export const Documents: FC<DocumentsProps> = ({ onAccept, onCancel }) => {
  const [selectedDocumentIndex, setSelectedDocumentIndex] = useState(0);
  const { url } = DOCUMENTS[selectedDocumentIndex];
  const onSelectDocumentIndex = (event: ReactMouseEvent<HTMLButtonElement>) => {
    const newIndex = parseInt(`${event.currentTarget.getAttribute('data-index') || 0}`, 10);

    setSelectedDocumentIndex(newIndex);
  };
  const onAcceptInternal = useCallback(() => {
    if (selectedDocumentIndex < DOCUMENTS.length - 1) {
      setSelectedDocumentIndex(selectedDocumentIndex + 1);
    } else {
      onAccept();
    }
  }, [selectedDocumentIndex, onAccept]);

  return (
    <Layout>
      <Left />
      <CenterLayout>
        <div role="group">
          {DOCUMENTS.map(({ label }, index) => (
            <button
              key={`DocTab:${index}`}
              onClick={onSelectDocumentIndex}
              data-index={index}
              className={index === selectedDocumentIndex ? 'primary' : 'secondary'}
            >
              {label}
            </button>
          ))}
        </div>
        <DocFrame src={`${url}#toolbar=0&navpanes=0&scrollbar=0`} />
        <Controls>
          <button onClick={onCancel}>Cancel</button>
          <button className="primary" onClick={onAcceptInternal}>
            Accept
          </button>
        </Controls>
      </CenterLayout>
      <Right />
    </Layout>
  );
};
